import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import FormProvider from '../hook-form/form-provider';

export const Wrapper = styled(FormProvider)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${(p) => p.theme.spacing(1)};
`;

export const Actions = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: ${(p) => p.theme.spacing(0.5)};
  &.actionDescription {
    justify-content: space-between;
  }
`;
